import ScrollReveal from "@/components/feature/ScrollReveal";
import { SANDO_INSTAGRAM_HANDLE, SANDO_INSTAGRAM_URL } from "@/mocks/site";
import { gallery } from "@/mocks/menu";

export default function InstagramStrip() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-10">
        <ScrollReveal className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <p className="text-xs font-medium uppercase tracking-[0.35em] text-accent-500">
              Instagram
            </p>
            <h2 className="mt-4 font-heading text-3xl leading-tight text-foreground-950 md:text-5xl">
              Síguenos entre panes
            </h2>
          </div>
          <a
            href={SANDO_INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-foreground-950 px-5 py-3 text-sm font-medium text-foreground-950 transition-colors duration-200 hover:bg-foreground-950 hover:text-background-50"
          >
            <i className="ri-instagram-line text-lg" aria-hidden="true" />
            {SANDO_INSTAGRAM_HANDLE}
          </a>
        </ScrollReveal>

        <div className="mt-10 grid grid-cols-2 gap-3 md:mt-12 md:grid-cols-4 md:gap-5">
          {gallery.map((item, index) => (
            <ScrollReveal key={item.id} delay={index * 70}>
              <a
                href={SANDO_INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="group block overflow-hidden rounded-lg border border-secondary-200"
                aria-label={`Ver ${SANDO_INSTAGRAM_HANDLE} en Instagram`}
              >
                <div className="aspect-square w-full overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.alt}
                    loading="lazy"
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
              </a>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}